<template>
    <SectionBasicLayout>
      <template #content>
          <div class="messages-dashboard">
            <div class="push-center">
                <div class="dashboard-header">
                    <i class="far fa-envelope"></i>
                    <p>
                      <strong>{{messages_selection.count}}</strong>
                      <span v-if="messages_selection.count > 1">
                        {{Language.say('messages.list.selection.messages')}}
                      </span>
                      <span v-else>
                        {{Language.say('messages.list.selection.message')}}
                      </span>
                      <strong>{{messages.folder_total}}</strong>
                      <span>{{Language.say('messages.list.selection.folder')}}</span>
                      <strong>{{folder.name}}</strong>
                    </p>
                </div>

                <div class="dashboard-actions">
                    <MessagesContextActions
                      :messages_selection='messages_selection'
                      :messages_view="messages_view"
                      :messages="messages"
                      :block="'dashboard_actions'"
                    />
                </div>
            </div>
          </div>
      </template>
    </SectionBasicLayout>
</template>

<script setup>
  import {defineProps, ref}     from 'vue';
  import MessagesContextActions from '../Partials/MessagesContextActions.vue';
  import SectionBasicLayout     from '@/vue/Layouts/Sections/SectionBasicLayout.vue';
  import Language               from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    folder_id          : {},
    messages_selection : {},
    messages_view      : {},
    webmail_view       : {},
    viewport_controller: {},
  })

  const messages = ref(props.viewport_controller.mailboxes.viewport.get(props.folder_id));
  const folder   = props.viewport_controller.mailboxes.folders.all.get(props.folder_id);
</script>
